import React, { useEffect, useState } from "react";
import {
  AppBar,
  Dialog,
  IconButton,
  Toolbar,
  Button,
  Box,
  Typography,
  Autocomplete,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useApi } from "../utils/api";

const TemplateSelectionModal = ({ open, onClose, onUseTemplate }) => {
  const { getWorkoutTemplates } = useApi();
  const [templates, setTemplates] = useState([]); // State to hold workout templates
  const [selectedTemplate, setSelectedTemplate] = useState(null); // State to hold selected template object
  const [loading, setLoading] = useState(false); // State to hold loading status

  useEffect(() => {
    const fetchTemplates = async () => {
      setLoading(true); // Set loading to true when fetching starts
      const response = await getWorkoutTemplates();
      const sortedTemplates = response.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
      setTemplates(sortedTemplates);
      setSelectedTemplate(sortedTemplates[0] || null);
      setLoading(false); // Set loading to false when fetching ends
    };

    if (open) {
      fetchTemplates();
    }
  }, [open, getWorkoutTemplates]);

  return (
    <Dialog open={open} onClose={onClose}>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Select Workout Template
          </Typography>
        </Toolbar>
      </AppBar>
      <Box sx={{ p: 2 }}>
        {loading ? ( // Show loader if loading
          <Typography>Loading templates...</Typography>
        ) : (
          <>
            <Autocomplete
              options={templates}
              getOptionLabel={(option) => option.name || ""}
              value={selectedTemplate}
              onChange={(event, newValue) => {
                setSelectedTemplate(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Template"
                  placeholder="Type to search..."
                />
              )}
              fullWidth
              sx={{ mb: 2 }}
              filterOptions={(options, { inputValue }) => {
                return options.filter((option) =>
                  option.name.toLowerCase().includes(inputValue.toLowerCase())
                );
              }}
            />
            <Button
              onClick={() => {
                onUseTemplate(selectedTemplate);
              }}
              disabled={!selectedTemplate}
            >
              Use Template
            </Button>
            <Button onClick={onClose}>Cancel</Button>
          </>
        )}
      </Box>
    </Dialog>
  );
};

export default TemplateSelectionModal;
